import React from "react"
import { Input } from "reactstrap"
class InputText extends React.Component {
  render() {
    return <Input {...this.props} type="textarea" />
  }
}

export default InputText
